export default __webpack_public_path__ + "static/media/packaged_turbofuel.a505bc1f.png";